export enum CookieEventType {
  CHANGED = 'aboveCloud_cookieChanged',
  DELETED = 'aboveCloud_cookieDeleted',
}
